
<template>
  <div v-url>
    <Loading v-if="!loaded"/>

    <!-- 开始-->
    <div class="main_container page_give">
        <UserInfo :giveUser="giveUser" :cover="cover"/>
        <Poster :showOpenAppBtn="showOpenAppBtn" :showPayBtn="showPayBtn" :cover="cover" :showDisconnectBtn="showDisconnectBtn" :showSendBackBtn="showSendBackBtn" :showSendBtn="showSendBtn" @take="openConfirm" :user="user" @showShare="openShare" @buildShare="buildShare"/>
        <Ad/>
        <TakeList :takeList="takeList"/>
        <Rule/>

        <VipMovie/>

        <Privilege/>

        <div class="mod_foot_list">
            <fieldset class="foot_list">
                <legend class="icon_logo_v"></legend>
            </fieldset>
        </div>
    </div>
    <!-- 结束-->

    <Result v-if="giveResult && giveResult.result" :giveResult="giveResult" :showPayBtn="showPayBtn"/>
    <ExplainPop/>
    <!--pc打开二维码提示 开始-->
    <div class="g_pc_screen" v-if="showQrCode">
        <div class="pc_mask"></div>
        <div class="pc_screen">
            <span class="qr_img"><img :src="pcQrCodeUrl" alt=""></span>
            <div class="desc_txt"><span class="txt">使用微信扫一扫,在手机上打开吧~</span></div>
        </div>
    </div>
    <!--pc打开二维码提示 结束-->
    <ConfirmTake v-if="showConfirm" @close="closeConfirm" @ok="actionTake"/>
    <Share v-show="showShare" ref="share" :giveUser="giveUser" :cover="cover" :user="user" @close="closeShare"/>
  </div>

</template>

<script>
import Loading from './components/Loading'
import Result from './components/Result'
import UserInfo from './components/UserInfo'
import Poster from './components/Poster'
import Ad from './components/Ad'
import TakeList from './components/TakeList'
import Rule from './components/Rule'
import Share from './components/Share'
import ExplainPop from './components/ExplainPop.vue'
import ConfirmTake from './components/ConfirmTake'
import VipMovie from './components/VipMovie'
import Privilege from './components/Privilege'
import { checkTakeMovie, takeMovie, checkGiveMovie, giveMovie, getCoverInfo } from './service/movie'
import cookie from '@tencent/vft-common/cookie'
import login from '@tencent/vft-common/login'
import util from '@tencent/vft-common/util'
import env from '@tencent/vft-common/env'
import { buildVipClass } from './util/vip'
import { hideShareButton } from './util/share'
import { getChannel } from './util/channel'
import { reportPlugin } from '@tencent/vft-vue-plugins'

const Theme_List = [{
  style: 'page_skin_01',
  type: ['剧情', '历史', '传记', '奇幻', '科幻'],
  privStyle: 'gold'
}, {
  style: 'page_skin_02',
  type: ['爱情', '喜剧', '家庭', '动画', '歌舞', '音乐'],
  privStyle: 'gold'
}, {
  style: 'page_skin_05',
  type: ['动作', '战争', '冒险', '犯罪'],
  privStyle: 'gold'
}, {
  style: 'page_skin_03',
  type: ['恐怖', '悬疑', '惊悚', '伦理'],
  privStyle: 'red'
}]

export default {
  data () {
    return {
      loaded: false,
      giveUser: {
        avatar: '//i.gtimg.cn/qqlive/images/20150608/avatar.png',
        nick: '',
        giveUserVipIcon: ''
      },
      cover: {
        coverTitleText: '',
        giveInfoText: '',
        iconStamp: '',
        posterOpenClass: ''
      },
      giveResult: {
        result: ''
      },
      user: {
        vipid: ''
      },
      showOpenAppBtn: true,
      showPayBtn: true,
      showDisconnectBtn: true,
      showSendBackBtn: true,
      showSendBtn: true,
      takeList: null,
      showConfirm: false,
      showShare: false
    }
  },
  async created () {
    // if (!this.cid) {
    //   return this.alert({
    //     msg: '参数格式不正确',
    //     confirm () {
    //       location.reload()
    //     }
    //   })
    // }
    this.cover.cid = this.cid
    try {
      let isLogin = await this.isLogin()
      if (!isLogin) {
        // return this.$openLogin()
      }
      this.$store.dispatch('getUserInfo')
      this.$store.dispatch('getPayVip')
    } catch (e) {
      // return this.$openLogin()
    }
    setTimeout(() => {
      reportPlugin.ready()
    }, 1500)

    this.initMovie()
    if (this.isTakeUser) {
      this.initTakePage()
    } else {
      this.initGivePage()
    }
  },
  methods: {
    async initMovie () {
      try {
        let coverInfo = await getCoverInfo(this.cid)
        this.cover.title = coverInfo.c_title
        this.cover.desc = coverInfo.c_second_title
        var subtype = coverInfo.c_subtype_name
        if (subtype) {
          var arrsubtype = subtype.split('+')
          if (arrsubtype > 1) {
            subtype = arrsubtype[1]
          }
        }
        // 初始化主题
        if (subtype && Theme_List && Theme_List.length > 0) {
          for (var i = 0; i < Theme_List.length; i++) {
            var isfind = false
            var themeItem = Theme_List[i]
            if (themeItem) {
              var types = themeItem.type
              var style = themeItem.style
              for (var j = 0; j < types.length; j++) {
                var type = types[j]
                if (subtype.indexOf(type) !== -1) {
                  document.getElementsByTagName('body')[0].className = style
                  // 初始化特权样式
                  isfind = true
                  break
                }
              }
            }
            if (isfind) {
              break
            }
          }
        }
      } catch (ex) {}
    },
    async initTakePage () {
      document.title = '领取影片'
      try {
        let takeInfo = await checkTakeMovie()
        this.loaded = true

        let code = takeInfo && takeInfo.result && takeInfo.result.code

        if (code === -11) {
          this.$openLogin()
          return
        }

        if (takeInfo.movie) {
          this.cover.title = takeInfo.movie.title
          this.cover.pic = takeInfo.movie.pic
          this.cover.paystatus = takeInfo.movie.paystatus
          this.cover.coverTitleText = `给您送了《${this.cover.title}》`

          if (this.cover.paystatus !== 4 && this.cover.paystatus !== 5) { // 未用券时，先隐藏分享按钮
            hideShareButton()
          }
        }
        if (takeInfo.giveuser) {
          this.giveUser.nick = takeInfo.giveuser.wxnick
          this.giveUser.head = takeInfo.giveuser.headimg
          document.title = `${this.giveUser.nick}给你赠送了《${this.cover.title}》`
        }

        if (takeInfo.vipid) {
          this.user.vipid = takeInfo.vipid
        }

        this.$refs.share.buildGiveMovieShare(this.taskid)

        if (code === 0) {
          this.showSendBackBtn = false
          if (takeInfo.taskinfo && takeInfo.taskinfo.leftnum > 0) {
            this.cover.giveInfoText = `剩余${takeInfo.taskinfo.leftnum}个，看谁手快`
          }
          this.showOpenAppBtn = false
          this.showPayBtn = false
        } else {
          var KEY_TAKEOPEN = ''
          if (this.isLogin()) {
            if (code === -10302) {
              if (this.payVipInfo && this.payVipInfo.vip !== 1) {
                this.showOpenAppBtn = false
              }
            }
            var userid = ''
            if (this.loginType() === 'wx') {
              userid = cookie.get('openid')
            } else {
              userid = login.getUin()
            }
            KEY_TAKEOPEN = ['h5_givemovie_open_', userid, '_', this.cid].join('')
          } else {
            if (code === -10302) {
              this.showOpenAppBtn = false
              this.showPayBtn = true
            }
          }

          if (code === -500010006) {
            // 已领取
            if (takeInfo.takeuser && takeInfo.takeuser.length > 0) {
              var take_user = null
              for (var i = 0; i < takeInfo.takeuser.length; i++) {
                var info = takeInfo.takeuser[i]
                if (info.uin === takeInfo.vipid) {
                  take_user = info
                  break
                }
              }
              if (take_user) {
                this.cover.iconStamp = 'icon_stamp_4'
                var endDate = take_user.endtime ? take_user.endtime.substr(take_user.endtime.indexOf('-') + 1, 11) : ''
                if (endDate) {
                  this.cover.giveInfoText = `已抢到${this.loginType() === 'wx' ? '微信' : 'QQ'}帐号<span class="name">${this.userInfo.nick}</span>上<br>抢到啦，观影有效期：${endDate}`
                }
              } else {
                if (takeInfo.movie && takeInfo.movie.paystatus === 8) {
                  this.cover.iconStamp = 'icon_stamp_5'
                } else {
                  this.cover.iconStamp = 'icon_stamp_2'
                }
              }
            }
            this.showDisconnectBtn = false
            this.cover.posterOpenClass = 'had_open'
          } else if (code === -206) {
            // 已购买
            if (takeInfo.movie && takeInfo.movie.paystatus === 8) {
              this.cover.iconStamp = 'icon_stamp_5'
            } else {
              this.cover.iconStamp = 'icon_stamp_2'
            }

            if (KEY_TAKEOPEN && localStorage && !localStorage.getItem(KEY_TAKEOPEN)) {
              this.cover.posterOpenClass = 'ani_open'
              localStorage.setItem(KEY_TAKEOPEN, '1')
            } else {
              this.cover.posterOpenClass = 'had_open'
            }
            this.showDisconnectBtn = false
          } else if (code === -209) {
            // 会员免费
            if (login.isLogin()) {
              this.cover.iconStamp = 'icon_stamp_3'
              this.showDisconnectBtn = false
              if (KEY_TAKEOPEN && localStorage && !localStorage.getItem(KEY_TAKEOPEN)) {
                this.cover.posterOpenClass = 'ani_open'
                localStorage.setItem(KEY_TAKEOPEN, '1')
              } else {
                this.cover.posterOpenClass = 'had_open'
              }
            }
          } else if (code === -10302) {
            // 抢光了
            this.cover.iconStamp = 'icon_stamp_1'
            this.showDisconnectBtn = false
            this.cover.posterOpenClass = 'had_open'
          } else {
            // -500010007 已过期
            // -500010008 影片已下架
            let msg = `请求失败，请稍候再试！${code}`
            if (code === -500010007 || code === -500010008) {
              msg = '该影片已不支持领取'
            }
            if (code === -10203) {
              msg = '影片赠送失败，暂时不支持领取哦'
            }
            // this.alert(msg)
            this.showOpenAppBtn = false
            this.showPayBtn = false
            this.showSendBackBtn = false
            hideShareButton()
          }
        }

        if (takeInfo.user_list) {
          this.giveUser.giveUserVipIcon = buildVipClass(takeInfo)
        }
        if (takeInfo.takeuser && takeInfo.takeuser.length > 0) {
          this.takeList = takeInfo.takeuser
        }

        let cookie_takemovie = cookie.get('givemovie_take') || util.getUrlParam('back')
        if (cookie_takemovie) {
          cookie.remove('givemovie_take', {
            domain: location.host,
            path: '/'
          })
          if (takeInfo && takeInfo.result && takeInfo.result.code === 0 && this.isLogin()) {
            this.actionTake()
          }
        }
      } catch (ex) {
        this.loaded = true
        // this.alert('请求失败，请稍候再试！')
        hideShareButton()
      }
    },
    async initGivePage () {
      document.title = '赠送影片'
      if (this.userInfo && this.userInfo.headurl) {
        this.user.avatar = this.userInfo.headurl
        this.user.nick = this.userInfo.nick
      }

      try {
        let giveInfo = {}
        this.loaded = true

        var code = giveInfo.result.code
        if (code === -11) {
          this.$openLogin()
          return
        }
        if (code === 0) {
          this.cover.title = giveInfo.cover.title
          this.cover.pic = giveInfo.cover.pic
          this.cover.paystatus = giveInfo.cover.paystatus
          // 赠送影片的观影有效期
          this.cover.pay_last_valid_date = giveInfo.cover.pay_last_valid_date
          this.user.vipid = giveInfo.vipid
          this.cover.coverTitleText = `您正在给好友赠送《${this.cover.title}》`
          this.cover.giveInfoText = `当前可赠送影片数：${giveInfo.activenum}`
          this.user.activenum = giveInfo.activenum
          if (giveInfo.taskinfo && giveInfo.taskinfo.tid) {
            this.cover.taskInfo = giveInfo.taskinfo
            // 已经赠送
            this.$refs.share.buildGiveMovieShare(giveInfo.taskinfo.tid)
          } else {
            // 没有赠送过该影片
            if (giveInfo.activenum && giveInfo.activenum > 0) {
              this.user.activenum = giveInfo.activenum
              // 还有赠送资格
              var cover_name = '该影片'
              if (giveInfo.cover && giveInfo.cover.title) {
                cover_name = `影片《${giveInfo.cover.title}》`
              }
              var isValid = giveInfo.cover.checkup && giveInfo.cover.checkup === 4
              if (!isValid) {
                // 下架影片
                // this.alert(`很抱歉，${cover_name}暂不支持赠送好友！`)
                this.showSendBtn = false
                hideShareButton()
              } else {
                if (this.cover.paystatus === 6 || this.cover.paystatus === 5) {
                  // 会员单点、会员only支持直接赠送
                  // this.$refs.share.buildGiveMovieShare()
                  this.buildShare()
                } else if (this.cover.paystatus === 4) {
                  // 会员用券需消耗一张券才可赠送，先隐藏分享
                  hideShareButton()
                } else {
                  let text = ''
                  if (giveInfo.cover.paystatus === 7) {
                    text = '很抱歉，' + cover_name + '为VIP付费影片，暂不支持赠送好友！'
                  } else if (giveInfo.cover.paystatus === 8 || giveInfo.cover.paystatus === 0) {
                    text = cover_name + '为非付费影片，无须赠送好友！'
                  } else {
                    text = '很抱歉，' + cover_name + '暂不支持赠送好友！'
                  }
                  console.log('text:', text)
                  // text && this.alert(text)
                  this.showSendBtn = false
                  hideShareButton()
                }
              }
            } else {
              // let that = this
              // this.alert({
              //   msg: '您当前没有赠片资格，开腾讯视频VIP获取赠片资格',
              //   confirm () {
              //     that.goToPay()
              //   }
              // })
              // 没有赠送资格
              hideShareButton()
            }
          }
        } else if (code === -500010005) {
          // this.alert('该影片暂不支持赠送好友！')
          this.showSendBtn = false
        } else {
          // this.alert(`请求失败，请稍候再试！(${code})`)
        }
        // this.matchUser()
      } catch (ex) {
        // this.alert('请求失败，请稍候再试！')
      }

      if (!env.isWechat && !env.isMqq && !env.isApp) {
        // this.alert('请在腾讯视频APP、微信、手机QQ中赠送影片')
      }
    },
    async actionTake () {
      this.report.click({ f_hottag: `h5_takemovie_${getChannel()}` })
      try {
        let takeInfo = await takeMovie({ vipid: this.user.vipid, nick: this.userInfo.nick, headurl: this.userInfo.headurl })
        let code = takeInfo && takeInfo.result && takeInfo.result.code
        if (code === -11) {
          this.$openLogin()
          return
        }

        if (code === 0) {
          this.cover.posterOpenClass = 'ani_open'
          this.cover.iconStamp = 'icon_stamp_4'
          this.showDisconnectBtn = false
          if (takeInfo.taker && takeInfo.taker.isVip === 1) {
            this.showSendBackBtn = true
            this.showPayBtn = false
          } else {
            this.showSendBackBtn = false
            this.showPayBtn = true
          }
          let endDate = takeInfo.enddate ? takeInfo.enddate.substr(takeInfo.enddate.indexOf('-') + 1, 11) : ''
          if (endDate) {
            this.cover.giveInfoText = `已抢到${this.loginType() === 'wx' ? '微信' : 'QQ'}帐号<span class="name">${this.userInfo.nick}</span>上<br>抢到啦，观影有效期：${endDate}`
          }
          this.takeList.push({
            takemsg: takeInfo.takemsg,
            wxnick: this.userInfo.nick,
            headimg: this.userInfo.headurl,
            taketime: takeInfo.begindate
          })
        } else {
          if (code === -500010006) {
            // 已领取
            // this.alert({
            //   msg: '你已领取该影片，无须重复领取',
            //   confirm () {
            //     location.reload()
            //   }
            // })
          } else if (code === -206) {
            // 已购买或已领取
            // this.alert({
            //   msg: '你已购买或领取该影片，无须重复领取',
            //   confirm () {
            //     location.reload()
            //   }
            // })
          } else if (code === -209) {
            // 会员免费
            // this.alert({
            //   msg: '该影片为VIP免费，无需领取即可观看',
            //   confirm () {
            //     location.reload()
            //   }
            // })
          } else if (code === -10302) {
            // 抢光了
            // this.alert({
            //   msg: '来晚啦，该影片已被抢完',
            //   confirm () {
            //     location.reload()
            //   }
            // })
          } else if (code === -500010007 || code === -500010008) {
            // -500010007 已过期
            // -500010008 影片已下架
            // this.alert('该影片已不支持领取')
          } else {
            // this.alert(`请求失败，请稍候再试！(${code})`)
          }
        }
      } catch (ex) {

      }
    },
    closeConfirm () {
      this.showConfirm = false
    },
    openConfirm () {
      this.showConfirm = true
    },
    matchUser () {
      if (util.getUrlParam('uin')) {
        if (login.loginType() === 'wx') {
          this.matchPop('qq')
        } else {
          if (login.getUin() !== util.getUrlParam('uin')) {
            if (login.isNewQQLogin()) {
              login.checkUser({
                type: 7,
                appid1: cookie.get('vqq_appid'),
                openid1: cookie.get('vqq_openid'),
                uin: util.getUrlParam('uin')
              }, function () {
              }, function () {
                this.matchPop('qq')
              })
            } else {
              this.matchPop('qq')
            }
          }
        }
      } else if (util.getUrlParam('vqq_openid') && util.getUrlParam('vqq_appid')) {
        let param
        if (login.isNewQQLogin()) {
          param = {
            type: 7,
            appid1: util.getUrlParam('vqq_appid'),
            openid1: util.getUrlParam('vqq_openid'),
            appid2: cookie.get('vqq_appid'),
            openid2: cookie.get('vqq_openid')
          }
        } else {
          param = {
            type: 7,
            appid1: util.getUrlParam('vqq_appid'),
            openid1: util.getUrlParam('vqq_openid'),
            uin: login.getUin()
          }
        }
        login.checkUser(param, function () {
        }, function () {
          this.matchPop('qq')
        })
      } else if (util.getUrlParam('openid') && util.getUrlParam('appid')) {
        if (login.loginType() === 'wx') {
          var param_openid = util.getUrlParam('openid')
          var param_appid = util.getUrlParam('appid')
          if (param_appid === cookie.get('appid')) {
            if (param_openid !== cookie.get('openid')) {
              this.alert({
                msg: '您手机登录的微信号和电脑登录的不一致，当前使用手机登录的微信号赠片',
                confirmText: '我知道了'
              })
            }
          } else {
            login.checkUser({
              type: 4,
              appid1: param_appid,
              openid1: param_openid,
              appid2: cookie.get('appid'),
              openid2: cookie.get('openid')
            }, function () {
            }, function () {
              this.alert({
                msg: '您手机登录的微信号和电脑登录的不一致，当前使用手机登录的微信号赠片',
                confirmText: '我知道了'
              })
            })
          }
        } else {
          this.matchPop('wx')
        }
      }
    },
    matchPop (type) {
      let that = this
      this.confirm({
        msg: '您手机登录的帐号和网页的不一致，是否切换为网页端帐号？',
        confirmText: '立即切换',
        confirm () {
          that.$switchLogin({ type })
        }
      })
    },
    closeShare () {
      this.showShare = false
    },
    openShare () {
      this.showShare = true
    },
    async buildShare () {
      try {
        let shareBack = await this.$refs.share.buildGiveMovieShare()
        try {
          let giveMovieResult = await giveMovie({
            vipid: this.user.vipid,
            nick: this.userInfo.nick,
            headurl: this.userInfo.headurl,
            param: shareBack
          })
          this.showShare = false
          if (giveMovieResult.result.code !== 0) {
            // 扣除赠片资格失败
            return this.alert({
              msg: giveMovieResult.result.msg || '很抱歉，扣除赠片资格失败，请重新赠送'
            })
          }
          // 扣除赠片资格成功
          this.giveResult.ticketNum = giveMovieResult.leftnum
          this.giveResult.result = 'suc'
        } catch (ex) {
        }
      } catch (ex) {
      }
    }
  },
  computed: {
    showQrCode () {
      return !env.isIPhone && !env.isAndroid && !env.isIpad
    },
    pcQrCodeUrl () {
      return `//sns.video.qq.com/tvideo/fcgi-bin/qrencode?size=150&url=${encodeURIComponent(location.href)}`
    }
  },
  components: {
    ExplainPop,
    Loading,
    Result,
    UserInfo,
    Poster,
    Ad,
    TakeList,
    Rule,
    VipMovie,
    Privilege,
    Share,
    ConfirmTake
  }
}
</script>
